import React, { useState } from 'react'
import CollectionGrid from './collection-grid'
import CollectionHeroes from './collection-heroes'
import CollectionTiledImages from './collection-tiled-images'

const Collection = ({ data, products, featuredProducts = [] }) => {
  if (data.active === false) return null

  switch (data.layout) {
    case 'grid':
      return (
        <CollectionGrid
          products={products}
          featuredProducts={featuredProducts}
        />
      )
    case 'heroes':
      return (
        <CollectionHeroes
          products={products}
          featuredProducts={featuredProducts}
        />
      )
    case 'tiledImages':
      return (
        <CollectionTiledImages
          products={products}
          featuredProducts={featuredProducts}
        />
      )
    default:
      return (
        <CollectionHeroes
          products={products}
          featuredProducts={featuredProducts}
        />
      )
  }
}

export default Collection
